import { Grid } from "@mui/material";
import { ExpandableSectionSummaryProps } from "models/propTypes/wintFormPropsTypes";
import React from "react";
import cssExports from "theme/styles/main.module.scss";

const ExpandableSectionSummary: React.FC<ExpandableSectionSummaryProps> = (props) => {
  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item container xs>
        <Grid item container alignItems="center">
          {props.title}
        </Grid>
      </Grid>
      {props.subText && (
        <Grid item className={cssExports.expansionPanelSubText}>
          <label>{props.subText}</label>
        </Grid>
      )}
    </Grid>
  );
};

export default ExpandableSectionSummary;
